export enum BooleanOption {
  YES = "YES",
  NO = "NO"
}
